export default "__VITE_ASSET__DQSO9YHu__"